<div class="savings-list__container">
  @for (item of savingsListView$ | async; track item) {
    <div class="savings-list__row" (click)="onPlanClick(item.plan)" (keydown.enter)="onPlanClick(item.plan)">
      <div class="savings-list__img">
        <img
          class="icon-size"
          [src]="item.image"
          (error)="img.src = '/assets/images/default-asset.svg'"
          [alt]="'logo_alt_text' | translate"
          #img />
      </div>
      <div class="savings-list__title">{{ item.title }}</div>
      <div class="savings-list__currency" hidePortfolioValue [isHideActive]="isHideValueActive$ | async">{{
        item.value
        | fiat_precision_symbol
        : { id: getFiat(item.plan).getId(), currencies: [getFiat(item.plan)], symbol: true }
      }}</div>
      <div class="savings-list__frequency">
        <img
          [src]="'/assets/images/history.svg'"
          [alt]="'recurring_buy_modal_frequency_label_frequency' | translate" />
        <span [title]="item.frequency">{{ item.frequency }}</span>
      </div>
      <div
        class="savings-list__status"
				[ngClass]="{
					'mod-active': item.state === 'active',
					'mod-pending': item.state === 'pending',
					'mod-paused': item.state === 'paused'
				}"
        >{{ "savings_plan_with_plans_status_" + item.state | translate }}</div
        >
      </div>
    }
  </div>
